import React from 'react'
import { ScaleLoader } from 'react-spinners'
import { SpinnerContainer } from '../../styles/CommonStyles'

const AuthLoading = (props) => {
	return (
		<>
			{props.loading && (
				<SpinnerContainer {...props}>
					<ScaleLoader size={15} color='#804BEB' />
				</SpinnerContainer>
			)}
		</>
	)
}

export default AuthLoading
